import { AUTH_CHANGE_EVENT_NAME, authService } from '../../services/auth';
import { onLocaleChange, t } from '../../services/i18n';
import { profileApi } from '../../services/profile.api';

export class RcAppAd extends HTMLElement {
  private advertisingEnabled = false;
  private isLoading = false;
  private disposeLocaleChange?: () => void;

  connectedCallback(): void {
    this.disposeLocaleChange = onLocaleChange(() => this.render());
    window.addEventListener(AUTH_CHANGE_EVENT_NAME, this.handleAuthChange as EventListener);
    void this.refresh();
  }

  disconnectedCallback(): void {
    this.disposeLocaleChange?.();
    window.removeEventListener(AUTH_CHANGE_EVENT_NAME, this.handleAuthChange as EventListener);
  }

  private handleAuthChange = (): void => {
    void this.refresh();
  };

  private async refresh(): Promise<void> {
    if (this.shouldHideByContext()) {
      this.advertisingEnabled = false;
      this.isLoading = false;
      this.render();
      return;
    }

    this.isLoading = true;
    this.render();

    try {
      const profile = await profileApi.get();
      this.advertisingEnabled = profile.advertisingEnabled !== false;
    } catch {
      this.advertisingEnabled = false;
    } finally {
      this.isLoading = false;
      this.render();
    }
  }

  private shouldHideByContext(): boolean {
    return !authService.isAuthenticated ||
      authService.isAdmin ||
      window.location.pathname.startsWith('/admin/');
  }

  render(): void {
    const shouldShow = !this.isLoading && !this.shouldHideByContext() && this.advertisingEnabled;
    this.hidden = !shouldShow;

    if (!shouldShow) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = `
      <section class="app-ad-card" data-testid="app-advertisement" aria-label="${t('appAdvertising.ariaLabel')}">
        <span class="app-ad-eyebrow">${t('appAdvertising.eyebrow')}</span>
        <div class="app-ad-panel">
          <div>
            <strong>${t('appAdvertising.title')}</strong>
            <p>${t('appAdvertising.body')}</p>
          </div>
          <div class="app-ad-marker" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <p class="app-ad-meta">${t('appAdvertising.meta')}</p>
      </section>
    `;
  }
}

if (!customElements.get('rc-app-ad')) {
  customElements.define('rc-app-ad', RcAppAd);
}
